import { render, staticRenderFns } from "./RiskDrillDown.vue?vue&type=template&id=ccb2aeb0&scoped=true&"
import script from "./RiskDrillDown.vue?vue&type=script&lang=js&"
export * from "./RiskDrillDown.vue?vue&type=script&lang=js&"
import style0 from "./RiskDrillDown.vue?vue&type=style&index=0&id=ccb2aeb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb2aeb0",
  null
  
)

export default component.exports